import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(): void {
    mixpanel.init('3d16e9dd996e630572e5f39d9a46ee18', {
      api_host: "https://api-eu.mixpanel.com",
    });    
  }

  /**
   * Identify user in mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  identify(userToken: string): void {    
    mixpanel.identify(userToken);
  }

  people(): any {
    return mixpanel.people;
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }
}
